import { render, staticRenderFns } from "./TruckDetailViewMeh.vue?vue&type=template&id=0684c566"
import script from "./TruckDetailViewMeh.vue?vue&type=script&lang=js"
export * from "./TruckDetailViewMeh.vue?vue&type=script&lang=js"
import style0 from "./TruckDetailViewMeh.vue?vue&type=style&index=0&id=0684c566&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports